import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { visitsKeys } from '../../api/query-keys/visits';

import { visitsApi } from '@/features/visits/api/lib/visits';
import { ApiError } from '@/types/interfaces/api-error';

export const useExtendVisit = (onSuccess?: () => void) => {
  const { t } = useTranslation(['visit']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ visitId, to }: { visitId: number; to: Date }) =>
      visitsApi.extendVisit(visitId, to),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: visitsKeys.all,
      });
      toast.success(t('visit:extendVisitDialog.extendSuccess'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      if (error?.response?.data?.name === 'ProlongationInProgressException') {
        toast.error(t('visit:extendVisitDialog.prolongError'));
      } else {
        toast.error(error?.response?.data?.message);
      }
    },
  });
};
